import { Component } from '@angular/core';

@Component({
  selector: 'app-home-associazione',
  templateUrl: './home-associazione.component.html',
  styleUrls: ['./home-associazione.component.css']
})
export class HomeAssociazioneComponent {

}
